/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Status_StandbyInputs */

const en_tasks_status_standby = /** @type {(inputs: Tasks_Status_StandbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standby`)
};

const fr_tasks_status_standby = /** @type {(inputs: Tasks_Status_StandbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const ms_sg2_tasks_status_standby = /** @type {(inputs: Tasks_Status_StandbyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tunggu sedia`)
};

/**
* | output |
* | --- |
* | "Standby" |
*
* @param {Tasks_Status_StandbyInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_status_standby = /** @type {((inputs?: Tasks_Status_StandbyInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Status_StandbyInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_status_standby(inputs)
	if (locale === "fr") return fr_tasks_status_standby(inputs)
	return ms_sg2_tasks_status_standby(inputs)
});